import { useMutation } from 'react-query';
import { useRecoilValue } from 'recoil';

import { HttpMethod } from '@api/enums';
import { createHttpClient } from '@api/http-client';
import { END_POINTS } from '@constants/api-endpoints';
import { AlertType } from '@enums/alert';
import { showAlert } from '@lib/alert/alert-manager';
import { AppRoutes } from '@routes/constants';
import { workspaceAtom } from '@store/atoms/workspace';
import { clearFromLocalStorage } from '@utils/auth';

import { usePusher } from './use-pusher';

export const useLogout = () => {
  const currentWorkspace = useRecoilValue(workspaceAtom);
  const { unsubscribeChannel } = usePusher(currentWorkspace.id);

  const client = createHttpClient();

  const mutation = useMutation(
    () =>
      client({
        method: HttpMethod.POST,
        url: END_POINTS.AUTH.LOGOUT,
      }),
    {
      onSuccess: () => {
        unsubscribeChannel();
        clearFromLocalStorage({ isLogout: true });

        window.history.pushState(
          null,
          '',
          window.location.origin + AppRoutes.LOGIN,
        );
        window.location.href = window.location.origin + AppRoutes.LOGIN;
      },
      onError: () => {
        showAlert({
          type: AlertType.ERROR,
          message: 'Failed to logout',
        });
      },
    },
  );

  return mutation;
};
